<template>
  <div class="pollute-wrap">
    <!--第一部分-->
    <div class="title">基于GIS规模化养殖场基本信息</div>
    <div class="box box-first">
      <div class="left-box">
        <ContentBox title="养殖场区域分布">
          <areaDistribute slot="boxBody"></areaDistribute>
        </ContentBox>
      </div>
      <div class="right-box">
        <div class="right-box-item right1">
          <ContentBox title="养殖场信息">
            <Tbalecomp slot="boxBody" :tableData=tableData1></Tbalecomp>
          </ContentBox>
        </div>
        <div class="right-box-item right2">
          <ContentBox title="养殖场畜禽信息">
            <Tbalecomp slot="boxBody" :tableData=tableData2></Tbalecomp>
          </ContentBox>
        </div>
        <div class="right-box-item right3">
          <ContentBox title="畜禽数量分析">
            <quantitativeAnalysis slot="boxBody"></quantitativeAnalysis>
          </ContentBox>
        </div>
      </div>
    </div>

    <!--第二部分-->
    <div class="title">本年度畜禽粪污产量及农田承载量预测预警</div>
    <div class="box box-second">
      <div class="left-box">
        <div class="right-box-item">
          <ContentBox title="畜禽污粪产量预测">
            <div class="chose-bar" slot="headerRight">
              <Picker :options="secondLeft1" @change="changeSecondLeft1"></Picker>
              <Picker :options="secondLeft2" @change="changeSecondLeft2"></Picker>
            </div>
            <yieldPrediction slot="boxBody"></yieldPrediction>
          </ContentBox>
        </div>
        <div class="right-box-item">
          <ContentBox title="畜禽污粪产生量">
            <Tbalecomp slot="boxBody" :tableData=tableData3></Tbalecomp>
          </ContentBox>
        </div>
      </div>
      <div class="right-box">
        <div class="right-box-item">
          <ContentBox title="农田承载总量预测">
            <Picker slot="headerRight" :options="secondRight" @change="changeSecondRight"></Picker>
            <totalForecast slot="boxBody"></totalForecast>
          </ContentBox>
        </div>
        <div class="right-box-item">
          <ContentBox title="农田种植品种预计承载量">
            <Tbalecomp slot="boxBody" :tableData=tableData4></Tbalecomp>
          </ContentBox>
        </div>
      </div>
    </div>

    <!--第三部分-->
    <div class="title">本年度畜禽粪污污染物检测预警</div>
    <div class="box box-third">
      <div class="left-box">
        <ContentBox title="主要污染物浓度监测结果——2018年2月25日">
          <Tbalecomp slot="boxBody" :tableData=tableData5></Tbalecomp>
        </ContentBox>
      </div>
      <div class="right-box">
        <ContentBox title="近一周主要污染物浓度每日变化趋势">
          <Picker slot="headerRight" :options="thirdRight" @change="changeThridRight"></Picker>
          <changeTrend slot="boxBody"></changeTrend>
        </ContentBox>
      </div>
    </div>

    <!--第四部分-->
    <div class="title">畜禽粪污资源化利用评估分析</div>
    <div class="box box-fourth">
      <div class="box1">
        <ContentBox title="年度畜禽粪污资源化利用率分析">
          <Picker :options="fourthLeft" @change="changeFourthLeft" slot="headerRight"></Picker>
          <useRatio slot="boxBody"></useRatio>
        </ContentBox>
      </div>
      <div class="box2">
        <ContentBox title="年度规模化畜禽粪污处理及转化的成本收益分析">
          <Picker :options="fourthCenter" @change="changeFourthCenter" slot="headerRight"></Picker>
          <Tbalecomp slot="boxBody" :tableData=tableData6></Tbalecomp>
        </ContentBox>
      </div>
      <div class="box3">
        <ContentBox title="规模化养殖场畜禽粪污处理成本收益回报分析">
          <div class="chose-bar" slot="headerRight">
            <Picker :options="fourthRight1" @change="changeFourthRight1"></Picker>
            <Picker :options="fourthRight2" @change="changeFourthRight2"></Picker>
          </div>
          <returnAnalysis slot="boxBody"></returnAnalysis>
        </ContentBox>
      </div>
    </div>
  </div>
</template>

<script>
  import ContentBox from 'components/jContentBox.vue';
  import Picker from 'components/picker.vue';
  import Tbalecomp from 'pages/pollute/tables/tablecomp.vue';
  import areaDistribute from 'pages/pollute/charts/areaDistribute'
  import changeTrend from 'pages/pollute/charts/changeTrend'
  import quantitativeAnalysis from 'pages/pollute/charts/quantitativeAnalysis'
  import returnAnalysis from 'pages/pollute/charts/returnAnalysis'
  import totalForecast from 'pages/pollute/charts/totalForecast'
  import useRatio from 'pages/pollute/charts/useRatio'
  import yieldPrediction from 'pages/pollute/charts/yieldPrediction'

  export default {
    name: "pollute",
    data() {
      return {
        tableData1: {
          th: ['养殖场名称', '主要养殖品种'],
          tb: [['鹰潭亚湾养殖场', '猪'], ['农机养殖场', '羊'], ['开发区养殖场', '鸡'], ['张庄养殖场', '鸡'], ['经开区养殖场', '鸡']]
        },
        tableData2: {
          th: ['年份', '养殖场名称', '畜禽种类', '存栏量'],
          tb: [['2017', '农机养殖场', '生猪', '5000头'], ['2016', '开发区养殖场', '鸡', '21000只'], ['2017', '鹰潭亚湾养殖场', '生猪', '4000头'], ['2016', '张庄养殖场', '鸡', '1000只']]
        },
        tableData3: {
          th: ['养殖场名称', '畜禽种类', '粪便产量', '尿液产量'],
          tb: [['农机养殖场', '生猪', '100kg', '100kg'], ['开发区养殖场', '鸡', '150kg', '0kg'], ['田园养殖场', '鱼', '80kg', '80kg'], ['木图养殖场', '鸡', '100kg', '0kg']]
        },
        tableData4: {
          th: ['承载品种种类', '承载量'],
          tb: [['水稻', '200kg/亩'], ['小麦', '300kg/亩'], ['玉米', '500kg/亩'], ['大豆', '600kg/亩']]
        },
        tableData5: {
          th: ['污染物', '监测浓度', '预警浓度', '是否超标预警'],
          tb: [['COD', '44mg/L', '50mg/L', '否'], ['BODS', '55mg/L', '60mg/L', '否'], ['TN', '80mg/L', '76mg/L', '是'], ['TP', '40mg/L', '20mg/L', '是'], ['SS', '46mg/L', '25mg/L', '是'], ['氨氮', '20mg/L', '16mg/L', '是']]
        },
        tableData6: {
          th: ['处理方式', '日处理能力', '处理成本', '收益'],
          tb: [['有机肥生产', '500t', '1万元/吨', '2万元/吨'], ['饲料加工', '490t', '5万元/吨', '3.4万元/吨'], ['沼气工程', '200t', '2.4万元/吨', '1.2万元/吨'], ['就近返田', '500t', '1万元/吨', '0.8万元/吨'], ['处理排放', '500t', '5万元/吨', '3万元/吨']]
        },
        secondRight: [{
          value: 'year',
          label: '年度预测'
        }, {
          value: 'month',
          label: '月度预测'
        }, {
          value: 'week',
          label: '周度预测'
        }, {
          value: 'day',
          label: '日度预测'
        }],
        secondLeft1: [{
          value: 'yawan',
          label: '鹰潭亚湾养殖场'
        }, {
          value: 'nongji',
          label: '农机养殖场'
        }, {
          value: 'kaifaqu',
          label: '开发区养殖场'
        }, {
          value: 'zhangzhuang',
          label: '张庄养殖场'
        }],
        secondLeft2: [{
          value: 'year',
          label: '年度预测'
        }, {
          value: 'month',
          label: '月度预测'
        }, {
          value: 'week',
          label: '周度预测'
        }, {
          value: 'day',
          label: '日度预测'
        }],
        thirdRight: [{
          value: 'yawan',
          label: '鹰潭亚湾养殖场'
        }, {
          value: 'nongji',
          label: '农机养殖场'
        }, {
          value: 'kaifaqu',
          label: '开发区养殖场'
        }, {
          value: 'zhangzhuang',
          label: '张庄养殖场'
        }],
        fourthLeft: [{
          value: '2018',
          label: '2018'
        }, {
          value: '2017',
          label: '2017'
        }, {
          value: '2016',
          label: '2016'
        }],
        fourthCenter: [{
          value: '2018',
          label: '2018'
        }, {
          value: '2017',
          label: '2017'
        }, {
          value: '2016',
          label: '2016'
        }],
        fourthRight1: [{
          value: 'yawan',
          label: '鹰潭亚湾养殖场'
        }, {
          value: 'nongji',
          label: '农机养殖场'
        }, {
          value: 'kaifaqu',
          label: '开发区养殖场'
        }, {
          value: 'zhangzhuang',
          label: '张庄养殖场'
        }],
        fourthRight2: [{
          value: '2018',
          label: '2018'
        }, {
          value: '2017',
          label: '2017'
        }, {
          value: '2016',
          label: '2016'
        }]
      }
    },
    methods: {
      changeSecondLeft1(val) {
        console.log(val)
      },
      changeSecondLeft2(val) {
        console.log(val)
      },
      changeSecondRight(val) {
        console.log(val)
      },
      changeThridRight(val) {
        console.log(val)
      },
      // 第四部分
      changeFourthLeft(val) {
        console.log(val)
      },
      changeFourthCenter(val) {
        console.log(val)
      },
      changeFourthRight1(val) {
        console.log(val)
      },
      changeFourthRight2(val) {
        console.log(val)
      },
    },
    components: {
      ContentBox,
      Picker,
      Tbalecomp,

      areaDistribute,
      changeTrend,
      quantitativeAnalysis,
      returnAnalysis,
      totalForecast,
      useRatio,
      yieldPrediction,
    }
  }
</script>

<style lang="scss" scoped>
  .pollute-wrap {
    width: calc(100% - 115px);
    padding: 20px;
    box-sizing: border-box;
    .title {
      color: #a1ffec;
      font-size: 16px;
      font-weight: bold;
      box-sizing: border-box;
      padding: 30px 0 20px 14px;
      position: relative;
      &:before {
        content: '';
        display: table-cell;
        width: 2px;
        height: 16px;
        background-color: #50ebc1;
        position: absolute;
        top: 34px;
        left: 0;
      }
      &:nth-child(1) {
        padding-top: 0px;
        &:before {
          top: 4px;
        }
      }
    }
    .box {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left-box, .right-box {
        width: calc((100% - 20px) / 2);
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        .right-box-item {
          width: 100%;
          .chose-bar {
            display: flex;
            justify-content: flex-end;
            align-items: center;
          }
        }
      }
    }
    .box-first {
      height: 552px;
      .right-box {
        /*.right-box-item {
          height: calc((100% - 20px) / 3);
        }*/
        .right1 {
          height: 178px;
        }
        .right2 {
          height: 143px;
        }
        .right3 {
          height: 213px;
        }
      }
    }
    .box-second {
      height: 460px;
      .right-box-item {
        height: calc((100% - 10px) / 2);
      }
    }
    .box-third {
      height: 358px;
    }
    .box-fourth {
      height: 358px;
      .box1, .box2, .box3 {
        height: 100%;
      }
      .box1 {
        width: calc((100% - 40px) / 3 - 100px);
      }
      .box2 {
        width: calc((100% - 40px) / 3);
      }
      .box3 {
        width: calc((100% - 40px) / 3 + 100px);
        .chose-bar {
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/pollute/pollute.vue